import React from 'react';
import AnimatedSection from '../common/AnimatedSection';


const LeadershipSection = () => {
    return (
        <section style={styles.altSection}>
            <div style={styles.container}>
                <AnimatedSection animation="fadeIn">
                    <h2 style={styles.sectionTitle}>Our <span style={styles.highlight}>Leadership</span></h2>
                    <div style={styles.sectionDivider}></div>
                    
                    <p style={styles.centeredText}>
                        Meet the visionaries driving innovation and excellence at Dee Cee Elevators
                    </p>
                    
                    <div style={styles.teamGrid}>
                        <div style={styles.teamCard}>
                            <div style={styles.teamImageContainer}>
                                <img 
                                    src="https://res.cloudinary.com/dknsjvavr/image/upload/v1753428289/WhatsApp_Image_2025-07-05_at_1.55.59_PM_kjjh75.jpg" 
                                    alt="Mr. Dinesh Chaudhary" 
                                    style={styles.teamImage}
                                />
                            </div>
                            <h3 style={styles.teamName}>Mr. Dinesh Choudhary</h3>
                            <p style={styles.teamRole}>Founder/Director</p>
                            <p style={styles.teamBio}>
                                A visionary leader driving innovation and growth with over 15 years of experience in the elevator industry.
                            </p>
                        </div>
                        
                        <div style={styles.teamCard}>
                            <div style={styles.teamImageContainer}>
                                <img 
                                    src= {"https://res.cloudinary.com/dknsjvavr/image/upload/v1753202166/vivek-agarwal_bjzyi2.jpg"}
                                    alt="Mr. Vivek Agarwal" 
                                    style={styles.teamImage}
                                />
                            </div>
                            <h3 style={styles.teamName}>Mr. Vivek Agarwal</h3>
                            <p style={styles.teamRole}>Founder/Director</p>
                            <p style={styles.teamBio}>
                                Expert in operations and strategic planning, ensuring optimal efficiency in all business processes.
                            </p>
                        </div>
                        
                        {/* <div style={styles.teamCard}>
                            <div style={styles.teamImageContainer}>
                                <img 
                                    src="/images/team/jitendra-singh.jpg" 
                                    alt="Mr. Jitendra Singh" 
                                    style={styles.teamImage}
                                />
                            </div>
                            <h3 style={styles.teamName}>Mr. Jitendra Singh</h3>
                            <p style={styles.teamRole}>Technical Director</p>
                            <p style={styles.teamBio}>
                                Specialist in technology and product development, leading our R&D initiatives for next-gen elevator systems.
                            </p>
                        </div> */}
                    </div>
                </AnimatedSection>
            </div>
        </section>
    );
};

const styles = {
    altSection: {
        padding: '90px 0',
        backgroundColor: '#f8fafc',
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
    },
    sectionTitle: {
        fontSize: '2.5rem',
        fontWeight: '800',
        textAlign: 'center',
        marginBottom: '15px',
        color: '#2c3e50',
    },
    highlight: {
        color: '#163ba2',
    },
    sectionDivider: {
        width: '80px',
        height: '4px',
        backgroundColor: '#163ba2',
        margin: '0 auto 50px',
        borderRadius: '2px',
    },
    centeredText: {
        textAlign: 'center',
        fontSize: '1.2rem',
        color: '#64748b',
        maxWidth: '800px',
        margin: '0 auto 50px',
        lineHeight: '1.6',
    },
    teamGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '40px',
        marginTop: '50px',
    },
    teamCard: {
        flex: '1 1 300px',
        maxWidth: '350px',
        backgroundColor: 'white',
        borderRadius: '10px',
        overflow: 'hidden',
        boxShadow: '0 15px 35px rgba(0, 0, 0, 0.08)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    },
    teamImageContainer: {
        width: '100%',
        height: '450px',
        overflow: 'hidden',
    },
    teamImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'top center',
        transition: 'transform 0.5s ease',
    },
    teamName: {
        fontSize: '1.5rem',
        fontWeight: '700',
        padding: '20px 20px 5px',
        color: '#2c3e50',
    },
    teamRole: {
        fontSize: '1rem',
        color: '#163ba2',
        fontWeight: '600',
        padding: '0 20px 15px',
    },
    teamBio: {
        fontSize: '1rem',
        lineHeight: '1.6',
        padding: '0 20px 25px',
        color: '#64748b',
    },
    '@media (max-width: 992px)': {
        sectionTitle: {
            fontSize: '2.2rem',
        },
        teamGrid: {
            gap: '30px',
        },
    },
    '@media (max-width: 820px)': {
        altSection: {
            padding: '70px 0',
        },
        sectionTitle: {
            fontSize: '2rem',
        },
    },
    '@media (max-width: 576px)': {
        altSection: {
            padding: '50px 0',
        },
        sectionTitle: {
            fontSize: '1.8rem',
        },
    }
};

export default LeadershipSection;